import type { ProjectId } from '../schema';
import isLoadingProjects from '../selectors/isLoadingProjects';
import hasSelectedProject from '../selectors/hasSelectedProject';
import isEmptyProjects from '../selectors/isEmptyProjects';
import { logSpacesDatapoint } from 'owa-timestream-logging';

export default function logProjectNotFound(projectId: ProjectId) {
    logSpacesDatapoint('OUTLOOKSPACES_PROJECT_NOT_FOUND', {
        isEmptyProjects: isEmptyProjects(),
        isLoadingProjects: isLoadingProjects(),
        hasSelectedProject: hasSelectedProject(),
        projectIdQueried: projectId,
    });
}
